import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Views
import LandingPage from './views/LandingPage';
import Qa from './views/Qa';
import Services from './views/Services';
import Policy from './views/Policy';
import Receipt from './views/Receipt';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

// UTIL
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
// import GoogleTagManager from './components/GoogleTagManager';
import ScrollToTop from './components/ScrollToTop';

// Footer
import { Footer } from './components/ui';
import logo from './assets/img/logo.svg';

import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import { Helmet } from 'react-helmet';
// Meta images
import twitterImage from './assets/img/twitter-image.jpg';
import ogImage from './assets/img/og-image.jpg';

ReactGA.initialize('UA-137619284-1');
ReactPixel.init('362569544349125');
ReactGA.plugin.execute('ecommerce');

class App extends Component {
    render() {
        const url = 'https://lagning.is/';
        const slogan = 'Góð geymsla fyrir bílinn meðan þú ferðast. Njóttu einfaldar og fljótlegrar þjónustu Lagningar';

        return (
            <div id="app">
                {/* <GoogleTagManager gtmId="GTM-KX7ZLGD" /> */}
                {/* Head meta tags etc.. */}
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Lagning - Tryggðu þér stæði</title>
                    <link rel="canonical" href={url} />

                    <meta name="description" content={slogan} />
                    <meta
                        name="keywords"
                        content={`leggja bílnum, bílastæði keflavík, bílageymsla, Lagning, Smart Parking, kef parking, keflavík airport, kefairport is, keflavíkurflugvöllur, leifsstöð, flugstöð leifs eiríkssonar, isavia, kef airport, kefairport, leifsstod is`}
                    />

                    {/* Twitter */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content="@lagning" />
                    <meta name="twitter:creator" content="@lagning" />
                    <meta name="twitter:title" content={'Lagning : Tryggðu þér snjallt stæði!'} />
                    <meta name="twitter:description" content={slogan} />
                    <meta name="twitter:image" content={twitterImage} />

                    {/* Facebook / Pinterest */}
                    <meta name="og:title" content="Lagning : Tryggðu þér snjallt stæði!" />
                    <meta name="og:type" content="website" />
                    <meta name="og:url" content={url} />
                    <meta name="og:image" content={ogImage} />
                    <meta name="og:description" content={slogan} />

                    <meta name="facebook-domain-verification" content="9okkcy5vswjij3xys2gb3ds5swr5b3" />
                </Helmet>
                <Router>
                    <ScrollToTop>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <ToastContainer autoClose={2000} />
                            <Switch>
                                <Route exact path="/" component={LandingPage} />
                                <Route exact path="/spurt-og-svarad" component={Qa} />
                                <Route exact path="/thjonustuferlid" component={Services} />
                                <Route exact path="/skilmalar" component={Policy} />
                                <Route path="/receipt/:id" component={Receipt} />
                            </Switch>
                            <Footer logo={logo}>
                                <ul>
                                    <li>Iðavöllum 9a</li>
                                    <li>230 Reykjanesbær</li>
                                    <li>lagning@lagning.is</li>
                                    <li>Sími 778 5999</li>
                                </ul>
                                {/* <Link to={'/skilmalar'}>
                                    <Button variant={'contained'} type="button" tabIndex={-1}>
                                        Skilmálar
                                    </Button>
                                </Link> */}
                                <em>Opið allan sólarhringinn</em>
                            </Footer>
                        </MuiPickersUtilsProvider>
                    </ScrollToTop>
                </Router>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js